import type { JDSModalMobileInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSModalMobileInternalProps>
  ): React.FC<JDSModalMobileInternalProps> =>
  (props: JDSModalMobileInternalProps) => {
    return (
      <Component
        {...{
          ...props,
          _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
        }}
      />
    );
  };
